import pushyApi from '../api/pushyApi';

class pushyServices {

  pushyRegisterToken(params) {
    return pushyApi.pushyRegisterToken(params).then(res => {
      try {
        return { success: res.success, message: res.message };
      } catch (e) {
        console.log('ERROR: urbanAirshipApi/upgradeChannelIdUrban:', res);
      }
    });
  }
}

export default new pushyServices();
